import "./index.0.css";
import { DataFormField } from '@tencent/data-schema/lib/vue-ui/DataForm';
import { INJECT_UICORE_BUS, INJECT_UICORE_RENDERER } from "../../../../lib/utils/consts";
const __script_base__ = {
  name: 'WField',
  components: {
    DataFormField
  },
  props: {
    path: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    fillLine: {
      type: Boolean,
      default: false
    },
    labelText: {
      type: String,
      default: ''
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    useCustomInput: {
      type: Boolean,
      default: false
    },
    uiSettings: {
      type: Object,
      default: null
    },
    tooltipText: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  },
  inject: {
    uc: {
      from: INJECT_UICORE_BUS,
      default: null
    },
    renderer: {
      from: INJECT_UICORE_RENDERER,
      default: null
    }
  },
  data() {
    return {
      inputId: '' // 仅限非自定义输入组件时候使用
    };
  },
  computed: {
    safePath() {
      var _this$path;
      return String((_this$path = this.path) !== null && _this$path !== void 0 ? _this$path : '');
    },
    dataFieldProp() {
      /** @type {import('@tencent/data-schema/lib/vue-ui/DataFormField').DataFormFieldProps} */
      const ans = {
        path: this.safePath,
        label: false // label 的展示由我承包了！
      };
      if (this.readonly) ans.readonly = true;
      if (this.uiSettings) ans.ui = {
        settings: this.uiSettings
      };
      return ans;
    },
    isValid() {
      var _stub$definedFields;
      const {
        useCustomInput,
        stub
      } = this;
      if (!stub) return false;
      if (!useCustomInput && stub.type === 'object' && !((_stub$definedFields = stub.definedFields) !== null && _stub$definedFields !== void 0 && _stub$definedFields.length)) return false; // 空对象
      return true;
    },
    isDesignMode() {
      return this.uc.isDesignMode;
    },
    safeLabelText() {
      if (this.hideLabel) return null;
      if (this.labelText) return this.labelText.trim();
      const {
        dataSchema
      } = this;
      if (!dataSchema) return null;
      return dataSchema.title || dataSchema.id;
    },
    actualDescription() {
      var _this$dataSchema;
      return String(this.description || ((_this$dataSchema = this.dataSchema) === null || _this$dataSchema === void 0 ? void 0 : _this$dataSchema.description) || '').trim();
    },
    stub() {
      var _this$renderer;
      return (_this$renderer = this.renderer) === null || _this$renderer === void 0 ? void 0 : _this$renderer.getStubAtPath(this.safePath);
    },
    dataStub() {
      return this.stub;
    },
    dataSchema() {
      var _this$stub;
      return (_this$stub = this.stub) === null || _this$stub === void 0 ? void 0 : _this$stub.schema;
    },
    fullPath() {
      var _this$stub2;
      return (_this$stub2 = this.stub) === null || _this$stub2 === void 0 ? void 0 : _this$stub2.path;
    }
  },
  methods: {
    syncInputId() {
      const {
        dsField
      } = this.$refs;
      this.inputId = dsField === null || dsField === void 0 ? void 0 : dsField.inputId;
    },
    patchCustomInput() {
      // const { stub } = this;

      // /** @type {Vue.VNode} */
      // const child = this.$slots.default?.[0];
      // if (!child) return null;

      // // 黑暗的直接修改子元素的 props

      // const overrides = {
      //   readonly: !!(stub?.readonly || this.readonly),
      // };

      // const propsData = child.componentOptions?.propsData;
      // const propsData2 = child.data.props;
      // const propsData3 = child.componentInstance?.$options?.propsData;

      // if (propsData) Object.assign(propsData, overrides);
      // if (propsData2) Object.assign(propsData2, overrides);
      // if (propsData3) Object.assign(propsData3, overrides);
    }
  },
  updated() {
    this.syncInputId();
  },
  mounted() {
    this.syncInputId();
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isValid || _vm.isDesignMode,
      expression: "isValid || isDesignMode"
    }],
    staticClass: "w-field",
    class: {
      "is-fillLine": _vm.fillLine
    },
    attrs: {
      "data-path": _vm.fullPath
    }
  }, [!!_vm.safeLabelText ? _c("div", {
    staticClass: "w-field-label"
  }, [_c("label", {
    staticClass: "w-field-label-text",
    attrs: {
      for: _vm.inputId,
      title: _vm.safeLabelText
    }
  }, [_vm._v("\n      " + _vm._s(_vm.safeLabelText) + "\n    ")]), _vm._v(" "), _vm.tooltipText ? _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.tooltipText) + "\n      ")]), _vm._v(" "), _c("i", {
    staticClass: "fa fa-info-circle w-field-label-tooltip"
  })], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "w-field-content"
  }, [_c("div", {
    staticClass: "w-field-input"
  }, [_vm.useCustomInput ? _c("div", {
    ref: "editorArea",
    staticClass: "w-field-customInputWrapper"
  }, [!_vm.$slots.default ? _c("div", {
    staticClass: "w-field-customInputWrapper-empty"
  }, [_vm._v("\n          在这里放置输入框组件，然后别忘记绑定数据源哦\n        ")]) : [_vm._v("\n          " + _vm._s(_vm.patchCustomInput()) + "\n          "), _vm._t("default")]], 2) : _c("DataFormField", _vm._b({
    key: "dsField",
    ref: "dsField"
  }, "DataFormField", _vm.dataFieldProp, false)), _vm._v(" "), _vm.isDesignMode && !_vm.isValid ? _c("div", {
    key: "invalidInputPlaceholder",
    staticClass: "w-field-invalidInputPlaceholder"
  }, [_vm._v("\n        无效字段组件 " + _vm._s(_vm.safePath) + "\n      ")]) : _vm._e()], 1), _vm._v(" "), _vm.actualDescription ? _c("div", {
    key: "desc",
    staticClass: "w-field-description"
  }, [_vm._v("\n      " + _vm._s(_vm.actualDescription) + "\n    ")]) : _vm._e()])]);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Field/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);